import axios from "../../utils/axios";

export const toggleDisLikeAPI = async (id, likes = 0, unlikes = 0) => {
    const response = await axios.patch(`/videos/${id}`, {
        likes, unlikes
    });

    return response.data;
};
